const mixin = {
    methods: {
        buildSelected(color, phone, index) {

            return { current: color, memory: phone.colors[index].memory, other: phone.colors, name: phone.name };
        },
    }
}

export default mixin